import { useLanguage } from "@/context/AppContext";

export default function Legacy() {
  const { t } = useLanguage();
  return (
    <section id="legacy" className="legacy" data-testid="legacy-section-container">
      <div className="legacy-content">
        <span className="kicker">{t.legacy.kicker}</span>
        <h2 data-testid="legacy-section-title">
          {t.legacy.l1}
          <br />
          <em>{t.legacy.l2}</em>
        </h2>
        <p>{t.legacy.p}</p>
        <a className="btn gold" href="#contact" data-testid="legacy-cta-button">
          {t.legacy.cta}
        </a>
      </div>
    </section>
  );
}
